import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { cols, mediaCSS } from 'blocks.app/config'
import { colors, IStyles } from 'theme'
import { defaultThemeStyles } from '../../content/content.theme'

const scrollbarXStyles: IStyles = {
    scrollbarX: {
        position: 'fixed',
        bottom: 0,
        height: 30,
        background: `var(--var-module-app-component-content-style-background, ${defaultThemeStyles.background})`,
        padding: '10px 36px',
    },
    scrollbarInner: {
        position: 'relative',
    },
    scrollbarHandle: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 8,
        background: colors.grey,
        cursor: 'grab',
        borderRadius: 5,
    },
    leftIndent: {
        left: `${cols.normal}%`,
        [mediaCSS.tab]: {
            left: 0,
        },
    },
    col2: {
        width: `${100 - 2 * cols.normal}%`,
        [mediaCSS.tab]: {
            ...grid.w100,
        },
    },
}

addStyles(scrollbarXStyles)
export default scrollbarXStyles
